<template>
  <div class="bg-s-50" data-testid="futures-page">
    <FuturesHeader
      title="Trade Lithium Futures on ICE with Benchmark Mineral Intelligence (BMI)"
      description="Accurate, Regulated Lithium Prices for the Battery Metals Market"
    />

    <AboutBMIAndICE>
      <p>
        Benchmark Mineral Intelligence (BMI) and Intercontinental Exchange (ICE)
        are proud to offer the industry-leading lithium futures contracts for
        lithium carbonate, lithium hydroxide, and spodumene.
      </p>
      <p>
        Used by the global battery supply chain to settle physical contracts,
        BMI provides trusted, regulated lithium pricing backed by deep industry
        expertise and real-world market data.
      </p>
    </AboutBMIAndICE>

    <TradeableFutures
      image-url="https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,dpr_auto/v1744123687/assets/ice/ice-lithium/57c01237039fc1eefb43e53b4e5872a8_sbq0ge.png?_i=AA"
      legend="All powered by Benchmark Mineral Intelligence's regulated price assessments."
    >
      <ul>
        <li> Lithium Hydroxide CIF Asia (BMI) Future </li>
        <li> Lithium Carbonate CIF Asia (BMI) Future </li>
        <li> Spodumene FOB Australia (BMI) Future </li>
      </ul>
    </TradeableFutures>

    <ContactSection>
      <p>
        Want to understand how lithium futures work or integrate BMI prices into
        your strategy?
      </p>
      <p> Ask our experts for a free consultation and demo. </p>
    </ContactSection>

    <WhyTradeBMI
      title="Why Trade BMI Lithium Futures?"
      feature01="Trusted by the world's leading battery supply chain participants"
      feature02="Benchmark prices used to settle physical lithium contracts"
      feature03="Transparent, regulated pricing methodology"
      feature04="Expert insights from pioneers in battery raw material pricing"
    />

    <KnowledgeAndConnection />

    <NewsletterMarketFormSection
      v-if="showNewsletterForm"
      image="https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,dpr_auto/v1744123685/assets/ice/ice-lithium/6f8eb5bd8e77972f9cf4ea320bc928ea_whlymt.png?_i=AA"
      title="Looking for key market updates? Sign up to our free Newsletter."
      :form-id="config.public.hubspotLithiumICENewsletterFormId"
      image-extra-classes="bg-center"
      with-overlay
    />
  </div>
</template>

<script lang="ts" setup>
import FuturesHeader from '~/components/futures-markets/Header.vue'
import AboutBMIAndICE from '~/components/futures-markets/AboutBMIAndICE.vue'
import TradeableFutures from '~/components/futures-markets/TradeableFutures.vue'
import ContactSection from '~/components/futures-markets/ContactSection.vue'
import WhyTradeBMI from '~/components/futures-markets/WhyTradeBMI.vue'
import KnowledgeAndConnection from '~/components/futures-markets/KnowledgeAndConnection.vue'
import NewsletterMarketFormSection from '~/components/unauth-market/NewsletterMarketFormSection.vue'

import { useSeo } from '~/composables/useSeo'
import { useUserEmailPreferences } from '~/composables/useUserEmailPreferences'

const config = useRuntimeConfig()

const { hasBenchmarkNewsletter } = useUserEmailPreferences()
const showNewsletterForm = computed(() => !hasBenchmarkNewsletter.value)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: 'Trade Lithium Futures on ICE | Benchmark Mineral Prices',
  description:
    'Trade lithium carbonate, hydroxide, and spodumene futures on ICE. Trusted, regulated prices from Benchmark Mineral Intelligence. Join the lithium trading community.',
})
useHead(seo)
</script>
